/* DogCare cart drawer upsell.
   One hero product, then quieter suggestions.
   Ranking comes from real co-purchase data (shop metafield dogcare.cart_affinity),
   with Shopify's recommendations API as a fallback.
   Lives in an asset so it survives Dawn's section re-render of .drawer__inner. */
(function () {
  'use strict';

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_LABEL = 'Προσθήκη';
  var HERO_LABEL = 'Πρόσθεσέ το';
  var HERO_BADGE = 'Οι περισσότεροι το παίρνουν μαζί';
  var productCache = {};

  function money(cents) {
    try {
      return '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
    } catch (e) {
      return '';
    }
  }

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function readAffinity(root) {
    var node = root.querySelector('script.dc-affinity');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent || 'null');
      return data && data.pairs ? data : null;
    } catch (e) {
      return null;
    }
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(ROOT_URL + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function build(root) {
    var rail = root.querySelector('.dc-upsell__rail');
    var heroSlot = root.querySelector('.dc-upsell__hero-slot');
    var moreLabel = root.querySelector('.dc-upsell__more');
    if (!rail || !heroSlot) return;

    var cartIds = (root.dataset.cartIds || '').split(',').filter(Boolean);
    var pinnedHandle = root.dataset.pinnedHandle || '';
    var mode = root.dataset.mode || 'true';
    var limit = parseInt(root.dataset.limit, 10) || 10;
    var maxCards = parseInt(root.dataset.max, 10) || 8;
    var affinity = readAffinity(root);

    function inCart(id) { return cartIds.indexOf(String(id)) !== -1; }

    function recommend(productId, intent) {
      var url = ROOT_URL + 'recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
      return fetch(url)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }

    /* Ranked handles from co-purchase data: sum the pair counts across every cart item. */
    function rankedFromAffinity() {
      if (!affinity) return [];
      var score = {};
      var handles = {};
      cartIds.forEach(function (id) {
        (affinity.pairs[id] || []).forEach(function (p) {
          if (inCart(p.id)) return;
          score[p.id] = (score[p.id] || 0) + Number(p.n || 0);
          handles[p.id] = p.handle;
        });
      });
      var ids = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
      /* pad with best sellers so a cart of an unusual product still gets suggestions */
      (affinity.top || []).forEach(function (t) {
        if (inCart(t.id) || score[t.id] != null) return;
        ids.push(String(t.id));
        handles[t.id] = t.handle;
      });
      return ids.map(function (id) { return handles[id]; }).filter(Boolean);
    }

    function collect() {
      var order = [];
      if (pinnedHandle) order.push(pinnedHandle);
      rankedFromAffinity().forEach(function (h) {
        if (order.indexOf(h) === -1) order.push(h);
      });

      var fromData = Promise.all(order.slice(0, maxCards + 2).map(fetchProduct));

      var fromApi = cartIds.length && (!affinity || order.length < 3)
        ? Promise.all(cartIds.map(function (id) {
            return recommend(id, 'complementary').then(function (list) {
              if (list.length > 0 || mode !== 'both') return list;
              return recommend(id, 'related');
            });
          })).then(function (lists) { return [].concat.apply([], lists); })
        : Promise.resolve([]);

      return Promise.all([fromData, fromApi]).then(function (res) {
        var seen = {};
        var out = [];
        res[0].concat(res[1]).forEach(function (p) {
          if (!p || !p.id) return;
          var key = String(p.id);
          if (seen[key] || inCart(key) || p.available === false) return;
          seen[key] = true;
          out.push(p);
        });
        return out.slice(0, maxCards);
      });
    }

    function addToCart(variantId, button, label) {
      var drawer = document.querySelector('cart-drawer');
      var body = {
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };

      fetch(ROOT_URL + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'cart error');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else {
            window.location.reload();
          }
        })
        .catch(function (e) {
          console.warn('[dc-upsell] add failed', e);
          button.disabled = false;
          button.textContent = label;
        });
    }

    function variantPicker(product, onChange) {
      var variants = product.variants || [];
      var available = variants.filter(function (v) { return v.available !== false; });
      if (available.length < 2) return { select: null, first: available[0] || variants[0] || {} };
      var select = document.createElement('select');
      select.setAttribute('aria-label', 'Επιλογή παραλλαγής');
      available.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title;
        select.appendChild(o);
      });
      select.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
        if (v) onChange(v);
      });
      return { select: select, first: available[0] };
    }

    function imageOf(product, first) {
      return (first && first.featured_image && first.featured_image.src) || (product.images && product.images[0]) || '';
    }

    function hero(product) {
      var wrap = el('div', 'dc-hero');

      var media = el('a', 'dc-hero__media');
      media.href = product.url;
      media.tabIndex = -1;
      var image = el('img', 'dc-hero__img');
      image.loading = 'lazy';
      image.alt = product.title || '';
      media.appendChild(image);
      wrap.appendChild(media);

      var body = el('div', 'dc-hero__body');
      var badge = el('span', 'dc-hero__badge');
      badge.textContent = HERO_BADGE;
      body.appendChild(badge);

      var name = el('a', 'dc-hero__name');
      name.href = product.url;
      name.textContent = product.title || '';
      body.appendChild(name);

      var prices = el('div', 'dc-hero__prices');
      var now = el('span', 'dc-hero__price');
      prices.appendChild(now);
      var wasEl = el('s', 'dc-hero__was');
      prices.appendChild(wasEl);
      body.appendChild(prices);

      var picker = variantPicker(product, function (v) {
        now.textContent = money(v.price);
        setCompare(v);
        if (v.featured_image && v.featured_image.src) image.src = v.featured_image.src;
      });
      var first = picker.first || {};

      function setCompare(v) {
        var c = v.compare_at_price || product.compare_at_price;
        if (c && Number(c) > Number(v.price)) {
          wasEl.textContent = money(c);
          wasEl.hidden = false;
        } else {
          wasEl.textContent = '';
          wasEl.hidden = true;
        }
      }

      now.textContent = money(first.price != null ? first.price : product.price);
      setCompare(first);
      var img = imageOf(product, first);
      if (img) image.src = img;

      if (picker.select) {
        picker.select.className = 'dc-hero__select';
        body.appendChild(picker.select);
      }

      var add = el('button', 'dc-hero__add');
      add.type = 'button';
      add.textContent = HERO_LABEL;
      add.addEventListener('click', function () {
        var variantId = picker.select ? picker.select.value : first.id;
        if (!variantId) return;
        add.disabled = true;
        add.textContent = '...';
        addToCart(variantId, add, HERO_LABEL);
      });
      body.appendChild(add);

      wrap.appendChild(body);
      return wrap;
    }

    function card(product) {
      var wrap = el('div', 'dc-card');
      wrap.setAttribute('data-product-id', product.id);

      var a = el('a', 'dc-card__link');
      a.href = product.url;
      a.tabIndex = -1;
      var image = el('img', 'dc-card__img');
      image.loading = 'lazy';
      image.alt = product.title || '';
      a.appendChild(image);
      wrap.appendChild(a);

      var name = el('a', 'dc-card__name');
      name.href = product.url;
      name.textContent = product.title || '';
      wrap.appendChild(name);

      var prices = el('div', 'dc-card__prices');
      var now = el('span', 'dc-card__price');
      prices.appendChild(now);
      wrap.appendChild(prices);

      var picker = variantPicker(product, function (v) {
        now.textContent = money(v.price);
        if (v.featured_image && v.featured_image.src) image.src = v.featured_image.src;
      });
      var first = picker.first || {};
      now.textContent = money(first.price != null ? first.price : product.price);
      var img = imageOf(product, first);
      if (img) image.src = img;

      if (picker.select) wrap.appendChild(picker.select);

      var add = el('button', 'dc-card__add');
      add.type = 'button';
      add.textContent = ADD_LABEL;
      add.addEventListener('click', function () {
        var variantId = picker.select ? picker.select.value : first.id;
        if (!variantId) return;
        add.disabled = true;
        add.textContent = '...';
        addToCart(variantId, add, ADD_LABEL);
      });
      wrap.appendChild(add);

      return wrap;
    }

    collect()
      .then(function (products) {
        if (!products.length || !document.body.contains(root)) return;

        heroSlot.innerHTML = '';
        heroSlot.appendChild(hero(products[0]));

        var rest = products.slice(1);
        rail.innerHTML = '';
        if (rest.length) {
          var frag = document.createDocumentFragment();
          rest.forEach(function (p) { frag.appendChild(card(p)); });
          rail.appendChild(frag);
          if (moreLabel) moreLabel.hidden = false;
        } else if (moreLabel) {
          moreLabel.hidden = true;
        }

        root.hidden = false;
      })
      .catch(function (e) {
        console.warn('[dc-upsell] skipped', e);
      });
  }

  /* Cart countdown next to the title. Armed for 10 minutes each time the
     number of items changes; hidden once it reaches zero. */
  var TIMER_KEY = 'dcCartTimer';
  var TIMER_MS = 10 * 60 * 1000;
  var timerTick = null;

  function timerState() {
    try { return JSON.parse(localStorage.getItem(TIMER_KEY) || 'null'); } catch (e) { return null; }
  }
  function timerSave(s) {
    try { localStorage.setItem(TIMER_KEY, JSON.stringify(s)); } catch (e) {}
  }
  function cartCount() {
    var c = document.querySelector('#CartDrawer .dc-head__count');
    var m = c && c.textContent.match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }
  function timerRender(el, s) {
    var left = s.end - Date.now();
    var boxes = document.querySelectorAll('#CartDrawer .dc-timer-box');
    if (left <= 0) {
      for (var i = 0; i < boxes.length; i++) boxes[i].hidden = true;
      return;
    }
    var sec = Math.ceil(left / 1000);
    var m = Math.floor(sec / 60), r = sec % 60;
    var txt = (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
    var vals = document.querySelectorAll('#CartDrawer .dc-timer__val');
    for (var j = 0; j < vals.length; j++) vals[j].textContent = txt;
    for (var k = 0; k < boxes.length; k++) boxes[k].hidden = false;
    /* every 10 seconds, a small wiggle on the checkout button as a reminder */
    if (sec % 10 === 0 && !reduceMotion()) {
      var btn = document.getElementById('CartDrawer-Checkout');
      if (btn && !btn.classList.contains('dc-going') && !btn.classList.contains('dc-wiggle')) {
        btn.classList.add('dc-wiggle');
        setTimeout(function () { btn.classList.remove('dc-wiggle'); }, 800);
      }
    }
  }
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function armTimer() {
    var el = document.getElementById('dc-timer');
    if (!el) return;
    var n = cartCount();
    if (!n) { el.hidden = true; return; }
    var s = timerState();
    if (!s || s.count !== n) {
      s = { count: n, end: Date.now() + TIMER_MS };
      timerSave(s);
    }
    timerRender(el, s);
    if (!timerTick) {
      timerTick = setInterval(function () {
        var t = document.getElementById('dc-timer');
        var st = timerState();
        if (t && st) timerRender(t, st);
      }, 1000);
    }
  }

  function init() {
    armTimer();
    var root = document.getElementById('dc-upsell');
    if (!root || root.dataset.built === '1') return;
    root.dataset.built = '1';
    build(root);
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(init, 60);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function start() {
    init();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Confetti burst on the drawer's add and checkout buttons.
   Self-contained canvas animation, no external library. */
(function () {
  'use strict';

  var COLORS = ['#d94565', '#f5c400', '#ffffff', '#121212', '#ff8fa8'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function burst(x, y, count) {
    if (reduce) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'dc-confetti';
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var parts = [];
    for (var i = 0; i < count; i++) {
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.9;
      var speed = 6 + Math.random() * 7;
      parts.push({
        x: x, y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        w: 5 + Math.random() * 5,
        h: 3 + Math.random() * 4,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: COLORS[i % COLORS.length],
        life: 1
      });
    }

    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var t = (ts - start) / 1000;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = false;
      parts.forEach(function (p) {
        p.vy += 0.35;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.life = Math.max(0, 1 - t / 1.1);
        if (p.life > 0) alive = true;
        ctx.save();
        ctx.globalAlpha = p.life;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (alive && t < 1.2) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(frame);
  }

  function centerOf(el) {
    var r = el.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  /* Checkout transition: the button turns into a loading state that stays
     until the checkout page takes over, so nothing is cut off mid-animation. */
  var TRANSITION_CSS =
    '#CartDrawer-Checkout{transition:transform .15s ease}' +
    '#CartDrawer-Checkout.dc-going{position:relative;overflow:hidden;pointer-events:none;transform:scale(.985)}' +
    '#CartDrawer-Checkout.dc-going::before{content:"";position:absolute;inset:0;' +
      'background:linear-gradient(100deg,transparent 30%,rgba(255,255,255,.28) 50%,transparent 70%);' +
      'transform:translateX(-100%);animation:dcSweep .9s ease-out .05s 1 forwards}' +
    '@keyframes dcSweep{to{transform:translateX(100%)}}' +
    '#CartDrawer-Checkout .dc-going__inner{display:inline-flex;align-items:center;gap:.9rem}' +
    '#CartDrawer-Checkout .dc-spin{width:1.6rem;height:1.6rem;border:2px solid rgba(255,255,255,.4);' +
      'border-top-color:#fff;border-radius:50%;animation:dcSpin .7s linear infinite;flex:0 0 auto}' +
    '@keyframes dcSpin{to{transform:rotate(360deg)}}' +
    '#CartDrawer-Checkout .dc-arrow{display:inline-block;animation:dcNudge .8s ease-in-out infinite}' +
    '@keyframes dcNudge{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}' +
    '#CartDrawer.dc-leaving .dc-scroll,#CartDrawer.dc-leaving .dc-ship{opacity:.55;transition:opacity .4s ease}';

  function ensureTransitionStyles() {
    if (document.getElementById('dc-checkout-transition')) return;
    var s = document.createElement('style');
    s.id = 'dc-checkout-transition';
    s.textContent = TRANSITION_CSS;
    document.head.appendChild(s);
  }

  /* Undo the transition when the visitor comes back from checkout (Safari and
     Chrome restore the page from cache with the faded state still applied). */
  function resetCheckoutTransition() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.remove('dc-leaving');
    var button = document.getElementById('CartDrawer-Checkout');
    if (!button) return;
    if (button.dataset.dcOriginal) button.innerHTML = button.dataset.dcOriginal;
    button.classList.remove('dc-going');
    button.removeAttribute('aria-busy');
    delete button.dataset.dcFired;
  }
  var leaveTimer = null;
  function resetIfBack() {
    if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
    resetCheckoutTransition();
  }
  window.addEventListener('pageshow', resetIfBack);
  window.addEventListener('pagehide', function () { setTimeout(resetCheckoutTransition, 0); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetIfBack();
  });
  window.addEventListener('focus', function () {
    var d = document.getElementById('CartDrawer');
    if (d && d.classList.contains('dc-leaving') && !leaveTimer) resetCheckoutTransition();
  });

  function goToCheckout(button) {
    ensureTransitionStyles();
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('dc-leaving');
    if (!button.dataset.dcOriginal) button.dataset.dcOriginal = button.innerHTML;
    button.classList.add('dc-going');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML =
      '<span class="dc-going__inner">' +
        '<span class="dc-spin" aria-hidden="true"></span>' +
        '<span>Μετάβαση στο checkout</span>' +
        '<span class="dc-arrow" aria-hidden="true">→</span>' +
      '</span>';

    var form = button.form || document.getElementById('CartDrawer-Form');
    /* safety net: timers freeze while the page sits in the back/forward cache and
       resume when the visitor returns, so this clears the faded state on return */
    if (leaveTimer) clearTimeout(leaveTimer);
    leaveTimer = setTimeout(function () { leaveTimer = null; resetCheckoutTransition(); }, 6000);
    setTimeout(function () {
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit(button);
      } else if (form) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '';
        form.appendChild(hidden);
        form.submit();
      } else {
        window.location.href = '/checkout';
      }
    }, 280);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('#CartDrawer .dc-hero__add, #CartDrawer .dc-card__add');
    if (add) {
      var c = centerOf(add);
      burst(c.x, c.y, add.classList.contains('dc-hero__add') ? 70 : 40);
      return;
    }
    var checkout = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (checkout && !checkout.disabled && !checkout.dataset.dcFired) {
      e.preventDefault();
      checkout.dataset.dcFired = '1';
      goToCheckout(checkout);
    }
  }, true);
})();
